import { inject, Injectable } from '@angular/core';
import { ApiHttpClient } from '@fullyops/shared/services/api-http-client.service';
import { Asset, AssetInput, ListedAsset, MiniAsset } from './asset';
import { Observable } from 'rxjs';
import { HistoryItem } from '../history/history';
import { ActionTypeLabel } from '../action-types/entities/action-type-entity';

export type AssetFilter =
  | { companyId?: string; compatibleWithActionType?: ActionTypeLabel }
  | { canBeParentOfId: string }
  | { canBeParentOfType?: string };

@Injectable({ providedIn: 'root' })
export class ApiAssetsAdapterService {
  private api = inject(ApiHttpClient);

  readonly create = this.api.creator<AssetInput>('assets');
  readonly attach = this.api.attacher('assets');
  readonly update = this.api.updater<AssetInput>('assets');
  readonly delete = this.api.deleter('assets');

  getById(id: string): Observable<Asset> {
    return this.api.http.get<Asset>(this.api.baseUrl + `assets/${id}/details`);
  }

  getAllMini(filter: AssetFilter): Observable<MiniAsset[]> {
    return this.api.http.get<MiniAsset[]>(this.api.baseUrl + 'assets/names', {
      params: filter,
    });
  }

  getAll(): Observable<ListedAsset[]> {
    return this.api.http.get<ListedAsset[]>(this.api.baseUrl + 'assets');
  }

  getHistoryById(id: string): Observable<HistoryItem[]> {
    return this.api.http.get<HistoryItem[]>(
      this.api.baseUrl + `assets/${id}/history`,
    );
  }
}
